import { render, staticRenderFns } from "./BaseProductSeriesConfigurationItem.vue?vue&type=template&id=bb52819e&scoped=true"
import script from "./BaseProductSeriesConfigurationItem.vue?vue&type=script&lang=js"
export * from "./BaseProductSeriesConfigurationItem.vue?vue&type=script&lang=js"
import style0 from "./BaseProductSeriesConfigurationItem.vue?vue&type=style&index=0&id=bb52819e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb52819e",
  null
  
)

export default component.exports